const optionArrayCache = {};

const getOptionArray = option => {
    let optionArray = optionArrayCache[option];
    if (!optionArray) {
        optionArray = [];
        let word = 9;
        for (let i = 0; i < option.length; i += 1) {
            let char = option.charCodeAt(i);
            let score = 1;
            if (char >= 65 && char <= 90) {
                score = 6;
                char += 32;
            }
            score += word;
            optionArray.push({
                value: option[i],
                lvalue: String.fromCharCode(char),
                score
            });
            word = char === 32 ? 7 : 0;
        }
        optionArrayCache[option] = optionArray;
    }
    return optionArray;
};

const match = (option, query, opts) => {
    const optionArray = getOptionArray(option);
    const matches = submatch(optionArray, 0, query.toLowerCase(), 0, 10);
    if (typeof matches === 'object') {
        let display = '';
        let p = 0;
        let open = false;
        for (let i = 0; i < option.length; i++) {
            if (i === matches.positions[p]) {
                if (!open) {
                    display += opts.pre || '<b>';
                }
                open = true;
                p++;
            } else if (open) {
                display += opts.post || '</b>';
                open = false;
            }
            display += option[i];
        }
        if (open) {
            display += opts.post || '</b>';
        }
        return {
            option,
            display,
            score: matches.score
        };
    } else if (matches) {
        return {
            option,
            display: option,
            score: 0
        };
    }
    return null;
};

const submatch = (option, o, query, q, acc) => {
    if (q === query.length) {
        return true;
    }
    if (o === option.length) {
        return null;
    }
    let bestResult;
    for (let i = o; i < option.length; i++) {
        if (query[q] === option[i].lvalue) {
            let score = option[i].score;
            if (i === o) {
                if (acc < 5) {
                    acc = 5;
                }
                if (score < acc) {
                    score = acc;
                }
            }
            const matches = submatch(option, i + 1, query, q + 1, score - 1);
            if (!matches) {
                break;
            }
            const result = {
                positions: [i],
                score
            };
            result.scores = [result.score];
            if (typeof matches === 'object') {
                result.positions = result.positions.concat(matches.positions);
                result.score += matches.score;
                // result.scores = result.scores.concat(matches.scores);
            }
            if (!bestResult || result.score > bestResult.score) {
                bestResult = result;
            }
        }
        acc = 0;
    }
    return bestResult;
};

export const filter = (options, query, opts) => {
    opts = opts || {};
    return options
        .reduce((prev, option, index, arr) => {
            let str = option;
            if (opts.extract) {
                str = opts.extract(option);
            }
            const result = match(str, query, opts);
            if (result != null) {
                result.option = option;
                prev[prev.length] = result;
            }
            return prev;
        }, [])
        .sort((a, b) => {
            const compare = b.score - a.score;
            if (compare) return compare;
            return a.index - b.index;
        });
};



// WEBPACK FOOTER //
// ./src/components/fuzzy.js